import './style.css';
import { useEffect } from 'react';

const Loading = ({ show = false, text = null }) => {
  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [show]);

  return (
    <div id='page-loader' className={`loader-overlay-dark ${!show ? 'hidden' : ''}`}>
      <div className='loader-container-dark'>
        <div className='loader-ring-dark'>
          <div className='ring-base-dark'></div>
          <div className='ring-spin-dark'></div>
        </div>
        {text && <span className='loader-text-dark'>{text}</span>}
      </div>
    </div>
  );
};

export default Loading;
